import _styled from "@emotion/styled/base";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../../primitives/Tab/components/Container.js';
import { Label } from '../../primitives/Tab/components/Label.js';
import { ICON_POSITION_END, ICON_POSITION_START } from '../../primitives/Tab/models.js';
export const Tab = /*#__PURE__*/_styled(forwardRef(({
  label,
  icon,
  active = false,
  disabled = false,
  wrap = false,
  iconPosition = ICON_POSITION_START,
  size = 'medium',
  backgroundColor,
  color,
  ...restProps
}, ref) => {
  return _jsxs(Container, {
    ...restProps,
    ref: ref,
    size: size,
    disabled: disabled,
    backgroundColor: backgroundColor,
    children: [icon && iconPosition === ICON_POSITION_START && icon, typeof label === 'string' ? _jsx(Label, {
      active: active,
      disabled: disabled,
      wrap: wrap,
      size: size,
      color: color,
      "data-label": label,
      children: label
    }) : label, icon && iconPosition === ICON_POSITION_END && icon]
  });
}), process.env.NODE_ENV === "production" ? {
  target: "e7uld2y0"
} : {
  target: "e7uld2y0",
  label: "Tab"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlRhYi5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFRSSIsImZpbGUiOiJUYWIuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBqc3ggYXMgX2pzeCwganN4cyBhcyBfanN4cyB9IGZyb20gXCJAZW1vdGlvbi9yZWFjdC9qc3gtcnVudGltZVwiO1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuaW1wb3J0IHsgZm9yd2FyZFJlZiB9IGZyb20gJ3JlYWN0JztcbmltcG9ydCB7IENvbnRhaW5lciB9IGZyb20gJy4uLy4uL3ByaW1pdGl2ZXMvVGFiL2NvbXBvbmVudHMvQ29udGFpbmVyLmpzJztcbmltcG9ydCB7IExhYmVsIH0gZnJvbSAnLi4vLi4vcHJpbWl0aXZlcy9UYWIvY29tcG9uZW50cy9MYWJlbC5qcyc7XG5pbXBvcnQgeyBJQ09OX1BPU0lUSU9OX0VORCwgSUNPTl9QT1NJVElPTl9TVEFSVCB9IGZyb20gJy4uLy4uL3ByaW1pdGl2ZXMvVGFiL21vZGVscy5qcyc7XG5leHBvcnQgY29uc3QgVGFiID0gc3R5bGVkKGZvcndhcmRSZWYoKHsgbGFiZWwsIGljb24sIGFjdGl2ZSA9IGZhbHNlLCBkaXNhYmxlZCA9IGZhbHNlLCB3cmFwID0gZmFsc2UsIGljb25Qb3NpdGlvbiA9IElDT05fUE9TSVRJT05fU1RBUlQsIHNpemUgPSAnbWVkaXVtJywgYmFja2dyb3VuZENvbG9yLCBjb2xvciwgLi4ucmVzdFByb3BzIH0sIHJlZikgPT4ge1xuICAgIHJldHVybiAoX2pzeHMoQ29udGFpbmVyLCB7IC4uLnJlc3RQcm9wcywgcmVmOiByZWYsIHNpemU6IHNpemUsIGRpc2FibGVkOiBkaXNhYmxlZCwgYmFja2dyb3VuZENvbG9yOiBiYWNrZ3JvdW5kQ29sb3IsIGNoaWxkcmVuOiBbaWNvbiAmJiBpY29uUG9zaXRpb24gPT09IElDT05fUE9TSVRJT05fU1RBUlQgJiYgaWNvbiwgdHlwZW9mIGxhYmVsID09PSAnc3RyaW5nJyA/IChfanN4KExhYmVsLCB7IGFjdGl2ZTogYWN0aXZlLCBkaXNhYmxlZDogZGlzYWJsZWQsIHdyYXA6IHdyYXAsIHNpemU6IHNpemUsIGNvbG9yOiBjb2xvciwgXCJkYXRhLWxhYmVsXCI6IGxhYmVsLCBjaGlsZHJlbjogbGFiZWwgfSkpIDogKGxhYmVsKSwgaWNvbiAmJiBpY29uUG9zaXRpb24gPT09IElDT05fUE9TSVRJT05fRU5EICYmIGljb25dIH0pKTtcbn0pKSBgYDtcbi8vIyBzb3VyY2VNYXBwaW5nVVJMPVRhYi5qcy5tYXAiXX0= */");